import { TRevenuesMonthly } from '../../api/APITypes';

export const MOCK_REVENUES_MONTHLY: TRevenuesMonthly = [
  {
    month: '2020-06',
    start_date: '2020-06-01',
    end_date: '2020-06-30',
    invoices_count: 13,
    total_margin: 30385.05,
    total_revenue: 240688.06999999998,
  },
  {
    month: '2020-03',
    start_date: '2020-03-01',
    end_date: '2020-03-31',
    invoices_count: 22,
    total_margin: 51984,
    total_revenue: 384865.68999999994,
  },
  {
    month: '2020-05',
    start_date: '2020-05-01',
    end_date: '2020-05-31',
    invoices_count: 25,
    total_margin: 67812.43000000001,
    total_revenue: 496614.18,
  },
  {
    month: '2020-10',
    start_date: '2020-10-01',
    end_date: '2020-10-31',
    invoices_count: 17,
    total_margin: 43576.82000000001,
    total_revenue: 315816.88,
  },
  {
    month: '2020-07',
    start_date: '2020-07-01',
    end_date: '2020-07-31',
    invoices_count: 26,
    total_margin: 66641.43999999999,
    total_revenue: 486609.89999999997,
  },
  {
    month: '2020-09',
    start_date: '2020-09-01',
    end_date: '2020-09-30',
    invoices_count: 22,
    total_margin: 42608.96,
    total_revenue: 340216.31,
  },
  {
    month: '2020-12',
    start_date: '2020-12-01',
    end_date: '2020-12-31',
    invoices_count: 26,
    total_margin: 71703.71,
    total_revenue: 560939.59,
  },
  {
    month: '2020-11',
    start_date: '2020-11-01',
    end_date: '2020-11-30',
    invoices_count: 14,
    total_margin: 33670.32,
    total_revenue: 271101.77999999997,
  },
  {
    month: '2020-02',
    start_date: '2020-02-01',
    end_date: '2020-02-29',
    invoices_count: 15,
    total_margin: 36961.85,
    total_revenue: 299858.29000000004,
  },
  {
    month: '2020-01',
    start_date: '2020-01-01',
    end_date: '2020-01-31',
    invoices_count: 28,
    total_margin: 71289.23,
    total_revenue: 519719.85999999987,
  },
  {
    month: '2020-08',
    start_date: '2020-08-01',
    end_date: '2020-08-31',
    invoices_count: 20,
    total_margin: 51839.04000000001,
    total_revenue: 422123.39999999997,
  },
  {
    month: '2020-04',
    start_date: '2020-04-01',
    end_date: '2020-04-30',
    invoices_count: 21,
    total_margin: 42451.369999999995,
    total_revenue: 315072.8300000001,
  },
];
